import React, { Component } from "react";
import InputList from "../../../shared/components/presentation/input-list/InputList";
import { Grid, GridItem } from "../../../shared/components/presentation/grid/Grid";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as regex from "../../../constants/regex";
import * as webAppointmentActions from "../../actions/webAppointmentActions";
import { nextPage } from "../../functions/nextPage";
import * as defaultState from "../../constants/DefaultState";
import { dropDownDefault, politeDropDownDefault } from "../../constants/webAppointmentConstants";
import * as strings from "../../constants/strings";
import * as formatData from "../../functions/formatData";
import dobFormatting from '../../../shared/functions/dobFormatting';
import apiGet from '../../../shared/functions/apiGet';


export class BillingAddressPage extends Component {
  states = [{ name: politeDropDownDefault, value: undefined }];
  constructor(props) {
    super(props);

    this.state = {
      isChecked: JSON.parse(window.localStorage.getItem('isChecked')) === "1" ? true : false,
      rerender: 1
    };

    if (this.state.isChecked) {
      const { relation, firstName, lastName, dob } = { ...this.props.insurance.policyHolder };

      this.props.webAppointmentSetBillingRelation(relation);
      this.props.webAppointmentSetBillingFirstName(firstName);
      this.props.webAppointmentSetBillingLastName(lastName);
      this.props.webAppointmentSetBillingDob(dob);
    }
  }

  setChecked(state) {
    window.localStorage.setItem('isChecked', JSON.stringify(state));
    let isCheckedState = state === "1" ? true : false;
    this.setState({ isChecked: isCheckedState });
  }

  getStates = () => {
    let options = { params: { country: "USA" } };
    return new Promise((resolve, reject) => {
      apiGet("/api/sitecore/webappointment/getStatesOrProvinces", options, null, null, null, false, false, false)
        .then((states) => {
          resolve(states);
        })
        .catch((error) => {
          console.log("get states call failed, falling back to hardcoded abbreviations.");
          console.log(error);
          let options = [
            { name: politeDropDownDefault, value: undefined },
            { name: "AL", value: "Alabama" },
            { name: "AK", value: "Alaska" },
            { name: "AZ", value: "Arizona" },
            { name: "AR", value: "Arkansas" },
            { name: "CA", value: "California" },
            { name: "CO", value: "Colorado" },
            { name: "CT", value: "Connecticut" },
            { name: "DE", value: "Delaware" },
            { name: "DC", value: "District of Columbia" },
            { name: "FL", value: "Florida" },
            { name: "GA", value: "Georgia" },
            { name: "HI", value: "Hawaii" },
            { name: "ID", value: "Idaho" },
            { name: "IL", value: "Illinois" },
            { name: "IN", value: "Indiana" },
            { name: "IA", value: "Iowa" },
            { name: "KS", value: "Kansas" },
            { name: "KY", value: "Kentucky" },
            { name: "LA", value: "Louisiana" },
            { name: "ME", value: "Maine" },
            { name: "MD", value: "Maryland" },
            { name: "MA", value: "Massachusetts" },
            { name: "MI", value: "Michigan" },
            { name: "MN", value: "Minnesota" },
            { name: "MS", value: "Mississippi" },
            { name: "MO", value: "Missouri" },
            { name: "MT", value: "Montana" },
            { name: "NE", value: "Nebraska" },
            { name: "NV", value: "Nevada" },
            { name: "NH", value: "New Hampshire" },
            { name: "NJ", value: "New Jersey" },
            { name: "NM", value: "New Mexico" },
            { name: "NY", value: "New York" },
            { name: "NC", value: "North Carolina" },
            { name: "ND", value: "North Dakota" },
            { name: "OH", value: "Ohio" },
            { name: "OK", value: "Oklahoma" },
            { name: "OR", value: "Oregon" },
            { name: "PA", value: "Pennsylvania" },
            { name: "PR", value: "Puerto Rico" },
            { name: "RI", value: "Rhode Island" },
            { name: "SC", value: "South Carolina" },
            { name: "SD", value: "South Dakota" },
            { name: "TN", value: "Tennessee" },
            { name: "TX", value: "Texas" },
            { name: "UT", value: "Utah" },
            { name: "VT", value: "Vermont" },
            { name: "VI", value: "Virgin Islands" },
            { name: "VA", value: "Virginia" },
            { name: "WA", value: "Washington" },
            { name: "WV", value: "West Virginia" },
            { name: "WI", value: "Wisconsin" },
            { name: "WY", value: "Wyoming" }
          ];
          this.states = options;
          // Tweak the state just enough to call render() again.
          this.setState((prevState) => { return { rerender: prevState.rerender + 1 }; });
        });
    });
  }

  fillStates() {
    this.getStates()
      .then((states) => {
        // process 'locations' - i.e. save locally so that render() can get to them.
        this.states = states.map(s => {
          return { value: s.Value, name: s.Value };
        })
        this.states.unshift({ name: politeDropDownDefault, value: undefined });
        // Tweak the state just enough to call render() again.
        this.setState((prevState) => { return { rerender: prevState.rerender + 1 }; });
      });
  }

  // Lifecycle Methods:
  componentDidMount() {
    this.fillStates();
  }

  isValid() {
    let valid = 
      this.props.insurance.billing.dob &&
      this.props.insurance.billing.dob.match(regex.DATE_OF_BIRTH_REGEX) &&
      this.props.insurance.billing.address1 && 
      this.props.insurance.billing.city && 
      this.props.insurance.billing.state && 
      this.props.insurance.billing.zip && 
      this.props.insurance.billing.zip.match(regex.ZIP_CODE_REGEX);

    if (this.props.forMe || this.props.insurance.whereToSend !== strings.TO_MY_ADDRESS) {
      valid = valid && 
        this.props.insurance.billing.relation && 
        this.props.insurance.billing.firstName && 
        this.props.insurance.billing.lastName;
    }

    return !!valid;
  }

  render() {
    const title = "Please provide billing information.";
    let possessiveSubtitle = this.props.forMe ? "your" : "the patient’s";
    let subtitle = `To streamline billing, we collect this information to add to ${possessiveSubtitle} MyChart account (if applicable).`;
    var shouldShowFirstFewFields = this.props.insurance.whereToSend !== strings.TO_MY_ADDRESS;
    let possessive = this.props.insurance.whereToSend === strings.TO_MY_ADDRESS ? "Your" : "Their";
    let inputlist = [
      shouldShowFirstFewFields ? 
        {
          fieldsetLegend: "",
          fieldsetColumns: 1,
          inputs: [
            !this.props.patientSeenRecently && 
            this.props.insurance.policyHolder.relation !== strings.ME && 
            this.props.insurance.policyHolder.relation !== strings.THE_PATIENT && 
            this.props.insurance.whereToSend === strings.SOMEWHERE_ELSE ? 
              {
                type: "checkbox",
                key: "checkbox-for-policy-holder",
                id: "same-as-policy-holder",
                label: "Same as the policy holder",
                checkboxWrapperClassName: "checkbox-wrapper",
                value: this.state.isChecked,
                checked: this.state.isChecked,
                onChange: () => {
                  if (this.state.isChecked) {
                    this.props.webAppointmentSetBillingRelation("");
                    this.props.webAppointmentSetBillingFirstName("");
                    this.props.webAppointmentSetBillingLastName("");
                    this.props.webAppointmentSetBillingDob("");
                    this.setChecked("0");
                    this.setState((prevState) => { return { rerender: prevState.rerender + 1 }; });
                  }
                  else {
                    const { relation, firstName, lastName, dob } = { ...this.props.insurance.policyHolder };
                    this.props.webAppointmentSetBillingRelation(relation);
                    this.props.webAppointmentSetBillingFirstName(firstName);
                    this.props.webAppointmentSetBillingLastName(lastName);
                    this.props.webAppointmentSetBillingDob(dob);
                    this.setChecked("1");
                  }
                }
              }
              : null,
              {
                type: "select",
                id: "relation",
                key: "relation-" + this.state.rerender,
                label: possessive + " relationship to " + (this.props.forMe ? "you" : "the patient"),
                onChange: (value) => {
                  this.setChecked("0");
                  this.props.webAppointmentSetBillingRelation(value === dropDownDefault ? "" : value);
                },
                existingContent: this.props.insurance.billing.relation || undefined,
                required: true,
                requiredError: "Please select " + possessive.toLowerCase() + " relationship to " + (this.props.forMe ? "you." : "the patient."),
                validateOnBlur: true,
                validationErrorClass: "web-appointment__error",
                options: [
                  { name: dropDownDefault, value: undefined },
                  { name: "Parent", value: "Parent" },
                  { name: "Guardian", value: "Guardian" },
                  { name: "Spouse", value: "Spouse" },
                  { name: "Partner", value: "Partner" },
                  { name: "Child", value: "Child" },
                  { name: "Sibling", value: "Sibling" },
                  { name: "Relative", value: "Relative" },
                  { name: "Friend", value: "Friend" },
                  { name: "Other", value: "Other" }
                ]
              }
          ]
        }
        : null, // end of fieldset.
      shouldShowFirstFewFields ? 
      {
        fieldsetLegend: "",
        fieldsetColumns: 2,
        inputs: [
          [
            {
              type: "text",
              id: "firstName",
              key: "firstName-" + this.state.rerender,
              label: possessive + " first name",
              onChange: (ev) => {
                this.setChecked("0");
                this.props.webAppointmentSetBillingFirstName(ev.target.value);
              },
              existingContent: this.props.insurance.billing.firstName || undefined,
              required: true,
              requiredError: "Please enter " + possessive.toLowerCase() + " first name.",
              validateOnBlur: true,
              validationErrorClass: "web-appointment__error",
              maxLength: "140"
            }
          ],
          [
            {
              type: "text",
              id: "lastName",
              key: "lastName-" + this.state.rerender,
              label: possessive + " last name",
              onChange: (ev) => {
                this.setChecked("0");
                this.props.webAppointmentSetBillingLastName(ev.target.value);
              },
              existingContent: this.props.insurance.billing.lastName || undefined,
              required: true,
              requiredError: "Please enter " + possessive.toLowerCase() + " last name.",
              validateOnBlur: true,
              validationErrorClass: "web-appointment__error",
              maxLength: "140"
            }
          ]
        ]
      }
      : null, // end of fieldset.
      {
        fieldsetLegend: "",
        fieldsetColumns: 1,
        inputs: [
          {
            id: "dob",
            key: "dob-" + this.state.rerender,
            type: "text",
            label: possessive + " date of birth",
            helperText: "Date format: mm/dd/yyyy",
            required: true,
            requiredError: "Please enter " + possessive.toLowerCase() + " date of birth.",
            maxLength: 10,
            patternMatch: regex.DATE_OF_BIRTH_REGEX,
            patternMatchError: "Please enter a valid date",
            placeholderText: "mm/dd/yyyy",
            validateOnBlur: true,
            validationErrorClass: "web-appointment__error",
            onChange: (ev) => {
              this.setChecked("0");
              this.props.webAppointmentSetBillingDob(ev.target.value);
            },
            onKeyUp: (ev) => {
              dobFormatting(ev, this, this.props.webAppointmentSetBillingDob);
            },
            existingContent: this.props.insurance.billing.dob || undefined
          },
          {
            type: "text",
            id: "address1",
            required: true,
            requiredError: "Please enter " + possessive.toLowerCase() + " street address.",
            validateOnBlur: true,
            validationErrorClass: "web-appointment__error",
            label: possessive + " address",
            helperText: "House number and street name",
            onChange: (ev) => {
              this.props.webAppointmentSetBillingAddress1(ev.target.value);
            },
            existingContent: this.props.insurance.billing.address1 || undefined,
            maxLength: "46"
          },
          {
            type: "text",
            id: "address2",
            label: possessive + " address continued (Optional)",
            helperText: "Apartment number if applicable",
            onChange: (ev) => {
              this.props.webAppointmentSetBillingAddress2(ev.target.value);
            },
            existingContent: this.props.insurance.billing.address2 || undefined,
            maxLength: "46"
          }
        ]
      }, // end of fieldset.
      {
        fieldsetLegend: "",
        fieldsetColumns: 3,
        inputs: [
          [
            {
              type: "text",
              id: "city",
              required: true,
              requiredError: "Please enter " + possessive.toLowerCase() + " city.",
              validateOnBlur: true,
              validationErrorClass: "web-appointment__error",
              label: possessive + " city",
              onChange: (ev) => {
                const formattedCity = formatData.formatCityString(ev.target.value);
                this.props.webAppointmentSetBillingCity(formattedCity);
              },
              existingContent: this.props.insurance.billing.city || undefined,
              maxLength: "140"
            }
          ],
          [
            {
              type: "select",
              id: "state",
              key: "state",
              required: true,
              requiredError: "Please enter " + possessive.toLowerCase() + " state.",
              validateOnBlur: true,
              validationErrorClass: "web-appointment__error",
              label: possessive + " state",
              onChange: (value) => {
                this.props.webAppointmentSetBillingState(value === politeDropDownDefault ? "" : value);
              },
              existingContent: this.props.insurance.billing.state ? this.props.insurance.billing.state.split("|")[0] : undefined,
              options: this.states
            }
          ],
          [
            {
              type: "text",
              id: "zip",
              required: true,
              requiredError: "Please enter " + possessive.toLowerCase() + " zip code.",
              patternMatch: regex.ZIP_CODE_REGEX,
              patternMatchError: "Please enter " + possessive.toLowerCase() + " zip code.",
              validateOnBlur: true,
              validateOnChange: true,
              validationErrorClass: "web-appointment__error",
              label: possessive + " zip code",
              onChange: (ev) => {
                const formattedZip = formatData.formatZipString(ev.target.value, ev.target.selectionStart);
                this.props.webAppointmentSetBillingZip(formattedZip);
              },
              existingContent: this.props.insurance.billing.zip,
              maxLength: "10"
            }
          ]
        ]
      }, // end of fieldset
      {
        fieldsetLegend: "",
        fieldsetColumns: 1,
        className: "button-order margin-top-medium",
        inputs: [
          [
            {
              type: "button",
              id: "back",
              className: "btn--secondary",
              value: "Back",
              onClick: () => {
                this.props.history.goBack();
              }
            },
            {
              type: "button",
              id: "next",
              className: "btn--primary",
              value: "Next",
              disabled: !this.isValid(),
              onClick: () => {
                this.props.history.push(nextPage());
              }
            }
          ]
        ]
      } // end of fieldset
    ];

    return (
      <React.Fragment>
        <Grid columns={1}>
          <GridItem>
            <div className="web-appt__header">
              <h1>{title}</h1>
              <p>{subtitle}</p>
              <hr />
            </div>
          </GridItem>
        </Grid>
        <InputList inputs={inputlist} isInlineList={false} />
      </React.Fragment>
    );
  }
}

BillingAddressPage.propTypes = {
  insurance: defaultState.insurancePropType,
  forMe: PropTypes.bool.isRequired,
  patientSeenRecently: PropTypes.bool.isRequired,
  webAppointmentSetBillingRelation: PropTypes.func.isRequired,
  webAppointmentSetBillingFirstName: PropTypes.func.isRequired,
  webAppointmentSetBillingLastName: PropTypes.func.isRequired,
  webAppointmentSetBillingDob: PropTypes.func.isRequired,
  webAppointmentSetBillingAddress1: PropTypes.func.isRequired,
  webAppointmentSetBillingAddress2: PropTypes.func.isRequired,
  webAppointmentSetBillingCity: PropTypes.func.isRequired,
  webAppointmentSetBillingState: PropTypes.func.isRequired,
  webAppointmentSetBillingZip: PropTypes.func.isRequired
};

function mapStateToProps(state, ownProps) {
  return {
    insurance: state.webAppointmentForm.insurance,
    forMe: state.webAppointmentForm.forMe,
    patientSeenRecently: state.webAppointmentForm.patientSeenRecently
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    webAppointmentSetBillingRelation: (value) => dispatch(webAppointmentActions.webAppointmentSetBillingRelation(value)),
    webAppointmentSetBillingFirstName: (value) => dispatch(webAppointmentActions.webAppointmentSetBillingFirstName(value)),
    webAppointmentSetBillingLastName: (value) => dispatch(webAppointmentActions.webAppointmentSetBillingLastName(value)),
    webAppointmentSetBillingDob: (value) => dispatch(webAppointmentActions.webAppointmentSetBillingDob(value)),
    webAppointmentSetBillingAddress1: (value) => dispatch(webAppointmentActions.webAppointmentSetBillingAddress1(value)),
    webAppointmentSetBillingAddress2: (value) => dispatch(webAppointmentActions.webAppointmentSetBillingAddress2(value)),
    webAppointmentSetBillingCity: (value) => dispatch(webAppointmentActions.webAppointmentSetBillingCity(value)),
    webAppointmentSetBillingState: (value) => dispatch(webAppointmentActions.webAppointmentSetBillingState(value)),
    webAppointmentSetBillingZip: (value) => dispatch(webAppointmentActions.webAppointmentSetBillingZip(value))
  };
};

// connects component to redux, and passes along the router
export default connect(mapStateToProps, mapDispatchToProps)(BillingAddressPage);
